/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from 'sarsaparilla';

const propTypes = {
    tripName: PropTypes.string,
    onChangeTripName: PropTypes.func,
    editable: PropTypes.bool,
    onClickShareTrip: PropTypes.func,
    onClickPrintTrip: PropTypes.func,
    lastSavedDate: PropTypes.string,
};

const defaultProps = {
    tripName: '',
};

export default class TripTitleInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isInEditMode: false,
            editableTripName: this.props.tripName,
        };

        this.onClickEdit = this.onClickEdit.bind(this);
        this.onClickSave = this.onClickSave.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.onClickShareTrip = this.onClickShareTrip.bind(this);
        this.onClickPrintTrip = this.onClickPrintTrip.bind(this);
    }

    onClickEdit() {
        this.previousState = { ...this.state };
        this.setState({ isInEditMode: true, editableTripName: this.props.tripName });
    }

    onClickSave() {
        delete this.previousState;
        this.setState({ isInEditMode: false });

        if (this.props.onChangeTripName) {
            this.props.onChangeTripName(this.state.editableTripName);
        }
    }

    onClickCancel() {
        const oldState = { ...this.previousState };
        this.setState(oldState);
        delete this.previousState;
        this.setState({ isInEditMode: false });
    }

    onClickShareTrip() {
        if (this.props.onClickShareTrip) {
            this.props.onClickShareTrip();
        }
    }

    onClickPrintTrip() {
        if (this.props.onClickPrintTrip) {
            this.props.onClickPrintTrip();
        }
    }

    onChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

    onKeyPress(event) {
        if (event.key === 'Enter') {
            this.onClickSave();
        }
    }

    getReadOnlyView() {
        let tripSaved = null;
        if (this.props.lastSavedDate) {
            tripSaved = <span>successfully saved</span>;
        }

        return (
            <div className="trip-planner-trip-title">
                <div className="trip-planner-trip-title-header">
                    <h3 className="title-label">Itinerary</h3>
                    <div>
                        <Button
                            appearance="link"
                            size="sm"
                            iconBeforeElement={<Icon iconName="print" />}
                            onClick={this.onClickPrintTrip}
                            screenReaderTextBefore="Print Trip Itinerary"
                        />

                        <Button
                            appearance="link"
                            size="sm"
                            iconBeforeElement={<Icon iconName="share" />}
                            onClick={this.onClickShareTrip}
                            screenReaderTextBefore="Share This Trip"
                        />
                    </div>
                </div>
                <div className="trip-title-view">
                    <div className="trip-title-actions">
                        {this.props.editable && (
                            <Button
                                appearance="link"
                                size="xs"
                                iconBeforeElement={<Icon iconName="edit" />}
                                onClick={this.onClickEdit}
                                screenReaderTextBefore="Edit trip title"
                            />
                        )}
                    </div>
                    <button
                        type="button"
                        onClick={this.onClickEdit}
                        title="Click to edit trip title"
                    >
                        <span className="h5">{this.props.tripName}</span>
                    </button>
                </div>
                <div className="trip-planner-trip-saved">{tripSaved}</div>
            </div>
        );
    }

    getEditView() {
        return (
            <div className="trip-planner-trip-title">
                <div className="trip-planner-trip-title-header">
                    <span className="title-label">Itinerary</span>
                </div>
                <div className="trip-title-input">
                    <input
                        onChange={this.onChange}
                        onKeyPress={this.onKeyPress}
                        value={this.state.editableTripName}
                        type="input"
                        name="editableTripName"
                        maxLength={100}
                    />
                    <button
                        type="button"
                        onClick={this.onClickSave}
                        className="rec-button-primary-small"
                    >
                        Save Title
                    </button>
                    <button
                        type="button"
                        onClick={this.onClickCancel}
                        className="rec-button-link"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        );
    }

    render() {
        if (this.state.isInEditMode) {
            return this.getEditView();
        }

        return this.getReadOnlyView();
    }
}

TripTitleInput.propTypes = propTypes;
TripTitleInput.defaultProps = defaultProps;
